<template>
  <div class="regcovid">
    <h4>新型コロナウイルス感染拡大防止のために</h4>
    <p>
      新型コロナウイルス感染拡大防止のために、以下の徹底を行っております。何卒ご理解ご協力のほどお願い申し上げます。
    </p>
    <ul>
      <li>① 1時間に一組のご案内とさせていただいております。</li>
      <li>② スタッフはマスクを着用させていただきます。</li>
      <li>③ 手指消毒スプレーを設置いたします。</li>
      <li>④ 会場は常に窓を開け、換気いたします。</li>
      <li>
        ※ご案内は先着順での受付になりますので、お時間の調整をさせていただく場合もございます。
      </li>
    </ul>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.regcovid {
  max-width: 960px;
  margin: $v-gap auto;
  padding: 0 $h-gap;
  box-sizing: content-box;
  h4 {
    color: $color_red;
    font-weight: bold;
    font-size: 1.5rem;
    margin-bottom: 1rem;
  }
  p {
    line-height: 1.5;
    margin-bottom: 2rem;
  }
  ul {
    display: grid;
    grid-gap: 1em;
    border-top: 1px solid $color_sub;
    border-bottom: 1px solid $color_sub;
    padding: 2em 0;
    li {
      font-weight: bold;
      &:last-child {
        font-weight: normal;
        font-size: 0.8em;
      }
    }
  }
}
</style>
